import { Text } from '#atoms';
import { PATH } from '#const/path';
import { ItemList } from '#organisims/DashboardCustomerInfo/AddMembership/ItemList';
import useScheduleMembership, {
  ScheduleMembership
} from '#pages/WeeklyCalenderScheduleRegistration/LectureScheduleContents/useScheduleMembership';
import { useScheduleManage } from '#providers/SchedulesManage';
import { useNavigate } from 'react-router';

interface WeeklyCalenderMembershipProps {}

const WeeklyCalenderMembership = ({}: WeeklyCalenderMembershipProps) => {
  const { selectedLecture } = useScheduleManage();

  const { setMembership } = useScheduleMembership();

  const navigate = useNavigate();

  const onClick = (params: ScheduleMembership) => {
    setMembership(params);
    navigate(-1);
  };

  const personId = selectedLecture.personId;

  return (
    <div className="p-20">
      <Text>수강권 목록</Text>

      <div className="w-full h-20"></div>

      <div className="flex flex-col gap-20">
        {/* <S.InputWrapper>
          <S.Input
            type="search"
            value={query}
            placeholder="수강권을 검색해주세요"
            onChange={e => {
              setQuery(e.target.value);
            }}
          />
          <S.Button>
            <Icon name="IconSearch" />
          </S.Button>
        </S.InputWrapper> */}

        <ItemList isScheduling onClick={onClick} personId={personId} />

        <div className="py-16 rounded-lg border-solid border-1 border-[#9170f2] justify-center items-center gap-4 inline-flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M9.1665 10.8334H4.1665V9.16669H9.1665V4.16669H10.8332V9.16669H15.8332V10.8334H10.8332V15.8334H9.1665V10.8334Z"
              fill="#7750E9"
            />
          </svg>
          <div
            onClick={() => {
              if (!personId) return;
              navigate(`${PATH.DASHBOARD_CUSTOMER_MEMBERSHIP}/${personId}`);
            }}
            className="text-[#7750e9] text-[17px] font-medium font-['Pretendard Variable'] leading-snug"
          >
            수강권 등록하기
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeeklyCalenderMembership;
